module.exports = __webpack_public_path__ + "static/media/eve-xrp.1a1ae489.svg";